// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4885 ? "75fc9c18" : chunkId) + "." + {"195":"d9f92f833543bc20","2741":"653c787f2490dc24","4162":"ac0d51939a4893a7","4885":"5a71081accd18d33","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};